/*
changeManager = new ChangeManager()

changeManager.recordUpdate(cid, entityType, oldentity, newentity, callback)
*/

var jsondiffpatch = require("jsondiffpatch").create();

import Amplify from "aws-amplify";
import API, { graphqlOperation } from "@aws-amplify/api";

console.log(jsondiffpatch);
console.log(jsondiffpatch.diff({ a: 1, c: 4, d: 5 }, { a: 2, b: 3, d: 5 }));

const createChangeLog = `mutation CreateChangeLog($input: CreateChangeLogInput!) {
    CreateChangeLog(input: $input) {
      id
    }
  }
  `;

export default class ChangeManager {
  constructor() {}
  readChanges(cid, fromDate) {}
  _record(createChangeLogInput, callback) {
    console.log("createChangeLogInput", createChangeLogInput);
    //graphqlOperation(createChangeLog, { input: createChangeLogInput })
    //API.graphql(graphqlOperation())
    //  .then(e=>callback(e, null))
    //  .catch(err=>{console.error(err);callback(null, err)})
  }
  recordCreate(cid, entityType, newentity, callback) {
    let createChangeLogInput = {
      userId: Amplify.Auth.user.username,
      companyId: cid,
      entityType: entityType,
      entityId: newentity.id,
      changeType: "CREATE",
      changeDoc: JSON.stringify(newentity),
    };
    this._record(createChangeLogInput, callback);
  }
  recordUpdate(cid, entityType, oldentity, newentity, callback) {
    var entityDiff = jsondiffpatch.diff(oldentity, newentity);
    if (oldentity.id !== newentity.id) {
      console.error("not same entity");
      return;
    }
    let createChangeLogInput = {
      userId: Amplify.Auth.user.username,
      companyId: cid,
      entityType: entityType,
      entityId: newentity.id,
      changeType: "UPDATE",
      changeDoc: JSON.stringify(entityDiff),
    };
    this._record(createChangeLogInput, callback);
  }
  recordDelete(cid, entityType, oldentity, callback) {
    let createChangeLogInput = {
      userId: Amplify.Auth.user.username,
      companyId: cid,
      entityType: entityType,
      entityId: oldentity.id,
      changeType: "DELETE",
      changeDoc: JSON.stringify(oldentity),
    };
    this._record(createChangeLogInput, callback);
  }
}

ChangeManager.install = function(Vue, options) {
  Vue.changeManager = new ChangeManager();
  Vue.prototype.$recordCreate = function(cid, entityType, newentity, cb) {
    Vue.changeManager.recordCreate(cid, entityType, newentity, cb);
  };
  Vue.prototype.$recordUpdate = function(cid, entityType, oldentity, newentity, cb) {
    Vue.changeManager.recordUpdate(cid, entityType, oldentity, newentity, cb);
  };
  Vue.prototype.$recordDelete = function(cid, entityType, oldentity, cb) {
    Vue.changeManager.recordDelete(cid, entityType, oldentity, cb);
  };
};
